var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame179(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4362 21.8598C44.4362 32.8999 36.2526 42.0271 25.6214 43.5082C24.6273 43.646 23.6103 43.718 22.578 43.718C21.3863 43.718 20.2162 43.6231 19.0766 43.4393C8.66901 41.7636 0.719727 32.7391 0.719727 21.8598C0.719727 9.78727 10.507 0 22.5795 0C34.652 0 44.4393 9.78727 44.4393 21.8598H44.4362Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0991 9.74951L20.0618 23.1111L10.0361 33.9715H12.2938L21.0687 24.4602L28.1603 33.9715H35.8378L25.3166 19.8604L34.6461 9.74951H32.3924L24.3097 18.5073L17.7806 9.74951H10.0991ZM13.4187 11.4143H16.9467L32.5222 32.3028H28.9941L13.4187 11.4143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame179);
export default __webpack_public_path__ + "static/media/Frame 179.ccc86049bf34a5d32479f6818013f140.svg";
export { ForwardRef as ReactComponent };